.IconButton {
  outline: none;
  margin: 0;
  padding: 0;
  padding: 4px;
  border-radius: 50%;
  width: fit-content;
  height: fit-content;
  line-height: 0;
  flex-shrink: 0;
  cursor: pointer;

  background-color: transparent;
  color: var(--color_neutral_800);

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.08);
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px var(--color_primary_500);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
